import { render } from "./Magnify.vue?vue&type=template&id=07ca3356"
import script from "./Magnify.vue?vue&type=script&lang=js"
export * from "./Magnify.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Magnify.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07ca3356"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07ca3356', __exports__)) {
    api.reload('07ca3356', __exports__)
  }
  
  module.hot.accept("./Magnify.vue?vue&type=template&id=07ca3356", () => {
    api.rerender('07ca3356', render)
  })

}


export default __exports__